/// <reference path="../Scripts/registry.d.ts" />

import { triggerRepository } from "./Widgets/triggers/triggerRepository";
import { actionRepository } from "./Widgets/Actions/actionRepository";
import { filterRepository } from "./Widgets/Filters/filterRepository";
import * as ko from "knockout";
import { fromJSON } from "knockout.mapping";

export * from "./type-selector";
declare var $;
declare var alertSuccess;
declare var alertError;

// declare var ko;

var tempConfigSrc = {
    rules: [
        {
            id: "rule1",
            throttle: {
                maxRepetitions: 3,
                maxPerSession: 1,
                minTimeout: undefined,
            },
            triggers: [
                {
                    type: "delay",
                    params: { timeToAction: 5 },
                },
            ],
            filters: [{ type: "language", params: { language: "sv" } }],
            action: {
                type: "alert",

                params: { text: "Hello from Action" },
            },
        },
        {
            id: "rule2",
            triggers: [
                {
                    type: "click",
                    params: { selector: "#yes-button" },
                },
            ],
            throttle: {
                maxRepetitions: undefined,
                maxPerSession: undefined,
                minTimeout: undefined,
            },
            filters: [],
            action: {
                type: "alert",
                params: { text: "Hello from click action" },
            },
        },
    ],
};
let ruleTemplate = {
    id: "[No name]",
    type: "",
    throttle: {
        maxRepetitions: ko.observable(null),
        maxPerSession: ko.observable(null),
        minTimeout: ko.observable(null),
    },
    triggers: [],
    filters: [],
    action: {
        type: ko.observable(null),
        params: {},
    },
};
function WidgetEditor() {
    this.availableActions = actionRepository;
    this.availableFilters = filterRepository;
    this.availableTriggers = triggerRepository;

    // console.log("this.availableTriggers", this.availableTriggers['delay'].triggerDescription);

    this.configuration = ko.observable();
    this.widgetData = ko.observable();
    this.isInitialized = ko.observable(false);

    this.selectedRuleIndex = ko.observable(null);

    this.isSelected = (row) => {
        if (row && this.selectedRule()) if (this.selectedRule().id == row.id) return true;
        return false;
    };

    this.loadConfiguration = () => {
        return $.fn.application.get("/widgets", this.configuration, { mapChildren: true }).done((cfg) => {
            console.log("loaded cfg", cfg);
            if (cfg.Data == null) {
                this.widgetData(ko.mapping.fromJS({ rules: [] }));
            } else {
                var widgetData = JSON.parse(cfg.Data);
                for (var i = 0; i < widgetData.rules.length; i++) {
                    widgetData.rules[i] = Object.assign({}, ruleTemplate, widgetData.rules[i]);
                    widgetData.rules[i].throttle = Object.assign(
                        {},
                        ruleTemplate.throttle,
                        widgetData.rules[i].throttle,
                    );
                    for (var it = 0; it < widgetData.rules[i].triggers.length; it++) {
                        var newTrigger = Object.assign(
                            {},
                            { type: ko.observable(), params: {} },
                            widgetData.rules[i].triggers[it],
                        );
                        widgetData.rules[i].triggers[it] = newTrigger;
                    }
                    for (var ifilter = 0; ifilter < widgetData.rules[i].filters.length; ifilter++) {
                        let newFilter = Object.assign(
                            {},
                            { type: ko.observable(), params: {} },
                            widgetData.rules[i].filters[ifilter],
                        );
                        widgetData.rules[i].filters[ifilter] = newFilter;
                    }
                }
                console.log("wd", JSON.stringify(widgetData));
                this.widgetData(ko.mapping.fromJS(widgetData));
            }

            this.isInitialized(true);
        });
    };
    this.publish = () => {
        return this.postChanges(true).done(() => {
            //   this.configuration().HasUnpublishedChanges(true);
        });
    };
    this.saveChanges = () => {
        return this.postChanges(false).done(() => {
            //  this.configuration().HasUnpublishedChanges(true);
        });
    };
    this.postChanges = (publish: boolean) => {
        let updatedConfiguration = ko.mapping.toJSON(this.widgetData, {});

        return $.fn.application
            .post("/widgets", { Data: updatedConfiguration, Publish: publish })
            .done((cfg) => {
                this.configuration(ko.mapping.fromJS(cfg));
                alertSuccess("success", "Saved widget");
            })
            .fail(() => {
                alertError("Failed", "Could not save widget");
            });
        console.log("updated conf", updatedConfiguration);
    };

    this.collapseIn = (index) => (this.selectedRule() && this.selectedRuleIndex() === index ? true : false);

    this.selectRule = (rule, index) => {
        console.log("selectRule", rule);

        this.selectedRuleIndex(index);

        return rule !== this.selectedRule() ? this.selectedRule(rule) : this.selectedRule(undefined);
    };

    this.selectedRule = ko.observable();

    this.filterAdd = () => {
        console.log(this.filters());
        this.rule.filters.push({ type: "", params: {} });
    };

    this.addRule = () => {
        this.widgetData().rules.push(ko.mapping.fromJS({ ...ruleTemplate }));
    };
    this.removeRule = (rule) => {
        console.log("removeRule");
        this.selectedRule(undefined);
        this.widgetData().rules.remove(rule);
    };
    this.addTrigger = () => {
        this.selectedRule().triggers.push({ type: ko.observable(), params: {} });
    };
    this.removeTrigger = (trigger: any) => {
        this.selectedRule().triggers.remove(trigger);
    };
    this.addFilter = () => {
        this.selectedRule().filters.push({ type: ko.observable(), params: {} });
    };
    this.removeFilter = (filter: any) => {
        this.selectedRule().filters.remove(filter);
    };
    this.finalJson = ko.observable();

    this.compute = ko.computed(() => {
        ko.toJSON(this.rule);
    });
    this.build = () => {
        this.finalJson(ko.toJSON(this.rule));
    };
}

declare var registry: any;
registry.registerComponent("web", "widget-editor", WidgetEditor);
